<template>
  <div class="content scrollbar">
    <div class="body-div">
      <router-view class="view" />
      <copyrightNotice v-show="show"></copyrightNotice>
    </div>
    <navbar></navbar>
  </div>
</template>

<script>
import navbar from './parts/navbar.vue';
import copyrightNotice from './parts/copyrightNotice.vue';
import home from './pages/home.vue';
import { isElementNotInViewport } from "./js/utils.js";
export default {
  name: 'App',
  components: {
    home,
    navbar,
    copyrightNotice
  },
  data() {
    return {
      header_Animate: false,
      show: false,
      screenWidth: document.body.clientWidth,
    }
  },
  mounted() {
    document.body.style.zoom = 1
    if (screen.width < 991) {
      this.show = true
    } else {
      // 监听滚动事件
      window.addEventListener("scroll", this.scrollToTop);
    }
  },
  beforeRouteLeave(to, form, next) {
    // 离开路由移除滚动事件
    window.removeEventListener('scroll', this.scrollToTop);
    this.show = false
    next();
  },
  methods: {
    // 滚动事件
    scrollToTop() {
      !isElementNotInViewport(this.$refs.header) ? this.header_Animate = true : '';
      // console.log(this.header_Animate);
      if (screen.width < 991) {
        this.header_Animate = false;
        this.show = true;
      } else {
        !isElementNotInViewport(this.$refs.header) ? this.header_Animate = true : '';
        this.show = true;
      }
    },
  },
}
</script>

<style>
@media screen and (min-width: 991px) {
  .body-div {
    margin-top: 168px;
  }
}

@media screen and (max-width: 991px) {
  .body-div {
    margin-top: 72px;
  }
}
</style>
